export const css = {
	oneaction: '_1p49MOcz',
	' _key': 'apic-theme/apic/quiz-widgets/questionfeedback'
};

export default css;
